<div *ngIf="value != null" class="container">
    <ng-container *ngIf="optionExpanded=='' || optionExpanded==null">
        <div class="block-title">
            <div class="title">{{ getResourcePhase() | translate:{ value: value.addressTitle } }}</div>
            <div class="subtitle">{{ value.addressLine1 }}</div>
        </div>
        <div class="phase-description">
            {{'SHARED.EXTERNAL.CMRS.TITLE' | translate:{ value: getCount() } }}
        </div>

        <div class="buttons-group">
            <div class="action-card card-documents" (click)="onClickLinkOption('Goods')">
                <div class="icon-wrapper">
                    <i class="hardman-pallet" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ getResourceGoods() | translate:{ value: getCount() } }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <div *ngIf="value.hasAccessDigitalDocument" class="action-card card-documents" (click)="onClickLinkOption('ControlDocument')">
                <div class="icon-wrapper">
                    <i class="fa fa-file-text" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ getResourceControlDocument() | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
            <!-- Sempre visible: un cop signat es pot veure la firma i continuar informant de problemes o comentant -->
            <div class="action-card" [ngClass]="value.isSignedConsignee ? 'card-documents' : 'card-singing'"
                (click)="onClickLinkOption('DocumentationPendingSigning')">
                <div class="icon-wrapper">
                    <i class="fa" [ngClass]="value.isSignedConsignee ? 'fa-check' : 'fa-pencil'" aria-hidden="true"></i>
                </div>
                <div class="card-body">
                    <div class="card-title">{{ (value.isSignedConsignee ? 'SHARED.EXTERNAL.CMR.PHASE.SHOWSIGNATURE'
                        : 'SHARED.EXTERNAL.CMR.ACTIONS.DOCUMENTATIONPENDINGSIGNING.CAPTION') | translate }}</div>
                </div>
                <i class="fa fa-chevron-right arrow-right" aria-hidden="true"></i>
            </div>
        </div>
    </ng-container>

    <!-- Mentre s'informa d'un problema o es comenta, la firma s'amaga ([hidden]) per no perdre el que s'estigui dibuixant -->
    <shared-sign *ngIf="optionExpanded=='DocumentationPendingSigning' || isSigningForm()" [hidden]="isSigningForm()"
        [uuid]="value.uuid" [agent]="signatureAgent" (signedChanged)="onPhaseSigned()">
        <shared-external-cmr-agent-phase-signactions sign-extra-actions [phaseUUID]="value.uuid" [agent]="agent"
            (reportProblem)="onClickLinkOption('Incident')" (addComment)="onClickLinkOption('Comment')"
            (resolveStandStill)="onClickLinkOption('StandStill')"></shared-external-cmr-agent-phase-signactions>
    </shared-sign>
    <shared-external-cmr-agent-incident *ngIf="optionExpanded=='Incident'" [phaseUUID]="value.uuid" [agent]="agent"
        (done)="collapse()"></shared-external-cmr-agent-incident>
    <shared-external-cmr-agent-standstill *ngIf="optionExpanded=='StandStill'" [phaseUUID]="value.uuid" [agent]="agent"
        (done)="collapse()"></shared-external-cmr-agent-standstill>
    <shared-external-cmr-agent-phase-comment *ngIf="optionExpanded=='Comment'" [phaseUUID]="value.uuid" [agent]="agent"
        (done)="collapse()"></shared-external-cmr-agent-phase-comment>
    <shared-external-cmr-agent-goods *ngIf="optionExpanded=='Goods'" [phaseUUID]="value.uuid" [agent]="agent"></shared-external-cmr-agent-goods>
    <shared-external-cmr-agent-listcmrs *ngIf="optionExpanded=='ControlDocument'" [phaseUUID]="value.uuid" [agent]="agent"></shared-external-cmr-agent-listcmrs>
    <div class="dummy"></div>
</div>